import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";

// Theme style
import "./lightTheme.scss";

//Redux
import { useSelector } from "react-redux";

const importDarkMode = (mainTheme) => {
  if (mainTheme === "dark") {
    require("./darkTheme.scss");
  }
};

const ScrollIcon = ({ qnt, onClick, isScrollable }) => {
  const { mainTheme } = useSelector((state) => state.Layout);

  const [scrollVisible, setScrollVisible] = useState(true);

  importDarkMode(mainTheme);

  useEffect(() => {
    if (qnt) setScrollVisible(true);
  }, [qnt]);

  return (
    <>
      {qnt > 0 && (
        <div
          className={`scrolldownIcon zoomIn ${
            (!scrollVisible && "zoomOut") || ""
          }`}
        >
          {<span>{qnt || ""}</span>}
          <Button
            color="primary d-flex justify-content-center align-items-center"
            onClick={(e) => {
              setScrollVisible(false);
              onClick(e);
            }}
          >
            <i className="bx bxs-chevron-down"></i>
          </Button>
        </div>
      )}
    </>
  );
};
export default ScrollIcon;
